import styled from 'styled-components'

export const StyledToggleFieldset = styled.fieldset`
    padding: 0;
    margin: 0;
    border: none;
`
